import axios from '../services/api.service';

export const benefitGetAll = async () => {
  try {
    const { data: response } = await axios.get('/benefits?limit=100');
    return {items: response.items, err: null};
  } catch (error) {
    return {res: null, err: error};
  }
};

export const benefitCreateOne = async (data: object) => {
  try {
    await axios.post('/benefits', data);
    return {message: 'success', err: null};
  } catch (error) {
    return {message: null, err: error};
  }
};